import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

import { type Credentials } from '../entities'

export async function fetchCredentials() {
  return await httpClientBanking<Credentials[]>({ url: '/me/credentials' })
}

export function useCredentials(options: { enabled?: boolean } = {}) {
  const { data, ...rest } = useQueryRequest<Credentials[]>(['credentials'], () => fetchCredentials(), {
    staleTime: 0,
    ...options
  })

  return { credentials: data?.data ?? [], ...rest }
}
